<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Сохранение выборки</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Название</label>
          <input type="text" class="form-control" v-model="name">
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['filters'],
    data () {
      return {
        name: '',
      }
    },
    methods: {
      save () {
        return api.post('samples', {
          filters: this.filters,
          name: this.name,
          path: this.$route.path,
        }).then((data) => {this.hide()})
      },
      hide () {
        this.$emit('hide')
      },
    }
  }
</script>
<style lang="scss">
  @import "boot";
  .app-modal {
    z-index: $zindex-modal + 3;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/sample-modal.vue